import React, { ReactElement, useState } from "react";
import { FormattedMessage } from "react-intl";

import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AntSwitch from "components/shared/switch/AntSwitch";

import { ILocations } from "types/api/serversApiInterface";

const HPublicVisibility = ({
 publicVisibility,
 disableNext,
 resetData,
 handleOpen,
 setData
}: {
 publicVisibility: boolean;
 disableNext: boolean;
 resetData: () => void;
 handleOpen: () => void;
 setData: (section: string, value: string | number | boolean | ILocations) => void;
}): ReactElement => {
 const [vPublic, setVPublic] = useState<boolean>(publicVisibility);

 const handleOpenModal = () => {
  setData("publicVisibility", vPublic);
  handleOpen();
 };

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="addons.cloudbucket.selectPublicVisibility" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id="addons.cloudbucket.selectPublicVisibilityMessage" />
    </Typography>
    <Stack spacing={2} px={2}>
     <Stack justifyContent="center" alignContent="center" direction="column">
      <FormControlLabel
       control={<AntSwitch checked={vPublic} onChange={(e) => setVPublic(e.target.checked)} />}
       label={
        <Typography ml={1}>
         <FormattedMessage id="addons.cloudbucket.publicVisibility" />
        </Typography>
       }
      />
     </Stack>
    </Stack>
   </Stack>
   <Stack direction="row" justifyContent="flex-end" alignItems="center">
    <Button onClick={resetData} sx={{ mt: 1, mr: 1 }}>
     <FormattedMessage id="server.add.reset" />
    </Button>
    <Button sx={{ mt: 1, mr: 1 }} disabled={disableNext} onClick={handleOpenModal}>
     <FormattedMessage id="server.add.confirm" />
    </Button>
   </Stack>
  </Paper>
 );
};

export default HPublicVisibility;
